module.exports = __webpack_public_path__ + "static/media/gradient-vertical-thin.0851d30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gradient-vertical-thin.png
// module id = 670
// module chunks = 0